import { render } from "./EditCampaign.vue?vue&type=template&id=1b80e314"
import script from "./EditCampaign.vue?vue&type=script&lang=js"
export * from "./EditCampaign.vue?vue&type=script&lang=js"

import "./EditCampaign.vue?vue&type=style&index=0&id=1b80e314&lang=css"

import exportComponent from "/Users/brianschroeter/Documents/Codex/2026-10-09/task/giving-dashboard-donor-fix/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__